import { CreateClientRequest } from "../../../types/client";

export default function validatePackages(clientData: CreateClientRequest) {
    const { 
        extraPackages, 
        scheduleFrom, 
        scheduleTo, 
        startTime: clientStartTime, 
        endTime: clientEndTime 
    } = clientData;

    const toDateTime = (date: string, time: string) => new Date(`${date}T${time}`);

    const toMinutes = (t: string) => {
        const [h, m] = t.split(":").map(Number);
        return h * 60 + m;
    };

    const chapelStart = toDateTime(scheduleFrom, clientStartTime);
    const chapelEnd   = toDateTime(scheduleTo, clientEndTime);

    for (const pkg of extraPackages) {
        const { startDate, endDate, startTime, endTime, packageName } = pkg;

        if (!startDate || !endDate || !startTime || !endTime) {
            return `Please provide a complete schedule for package ${packageName}.`;
        }

        if (toMinutes(endTime) > toMinutes("20:59")) {
            return `The end time must not exceed 8:59 PM for package ${packageName}.`;
        }

        const pkgStart = toDateTime(startDate, startTime);
        const pkgEnd   = toDateTime(endDate, endTime);

        if (isNaN(pkgStart.getTime()) || isNaN(pkgEnd.getTime())) {
            return `Invalid date or time for package ${packageName}.`;
        }

        if (pkgEnd <= pkgStart) {
            return `End date and time must be after start date and time (${packageName}).`;
        }

        if (pkgStart < chapelStart) {
            return `Package start date and time must not be earlier than the client's start date and time (${packageName}).`;
        }

        if (pkgEnd > chapelEnd) {
            return `Package end date and time must not exceed the client's end date and time (${packageName}).`;
        }
    }

    return null;
}